import { CButtonGroup, CButtonToolbar, CButton, CDropdown, CDropdownDivider, CDropdownHeader, CDropdownItem, CDropdownItemPlain, CDropdownMenu, CDropdownToggle, CFormCheck, CFormInput, CInputGroup, CInputGroupText } from '@coreui/bootstrap-react/src/index';
import * as React from 'react';
export default {
  CButtonGroup,
  CButtonToolbar,
  CButton,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownItemPlain,
  CDropdownMenu,
  CDropdownToggle,
  CFormCheck,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  React
};